module.exports = __webpack_public_path__ + "img/38452de.jpg";